import { createContext } from "react";

export interface NotificationType {
  currentTab: number;
  filterType: NotificationFitlerType[];
}

interface InitialStateType {
  notificationState: NotificationType;
  notificationSetState: any;
}

const NotificationContext = createContext<InitialStateType[]>([]);

export default NotificationContext;
